module.exports = __webpack_public_path__ + "3fdb1d3b87c2c061069f21321feffa39.png";